import { createReducer, on } from '@ngrx/store';

import { BetslipSourcePageActions } from '../source-page.actions';
import { defaultSourcePageState } from '../source-page.state';

export const sourcePageStateReducer = createReducer(
    defaultSourcePageState,
    on(BetslipSourcePageActions.setSourcePage, (state, action) => {
        const sourcePageState = action.payload;

        return {
            ...state,
            ...sourcePageState,
        };
    }),
);
